/**
 * Styled Components - Created by gustavomedina on 07/06/18.
 */
import styled from 'styled-components'
import Input from 'antd/lib/input'
import Upload from 'antd/lib/upload'
import { RED, WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

export const Container = styled.div`
  padding: 27px 0;
  background-color: #fff;
`

export const Text = styled.div`
  color: #5f6062;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3px;
  line-height: 33px;
  text-align: center;
`

export const ButtonsRow = styled.div`
  padding: 90px 0 40px;
  display: flex;
  justify-content: center;

  @media (min-width: 320px) and (max-width: 480px) {
    padding: 30px 0px 20px;
    flex-direction: column;
  }
`
export const AnchorButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 220.37px;
  margin-left: 51px;
  border: 2px solid #e61737;
  border-radius: 2px;
  color: #e61737;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    margin-bottom: 10px;
  }
`
export const SectionContainer = styled.div`
  margin-bottom: 60px;
`

export const SectionTitle = styled.div`
  color: #5f6062;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
  text-align: center;
`

export const SectionSubTitle = styled.div`
  color: #5f6062;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
  text-align: center;
`

export const SectionText = styled.div`
  padding: 30px 40px 0;
  color: #5f6062;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;

  .highlight {
    color: red;
    font-style: italic;
  }

  b {
    font-weight: 700;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    padding: 30px 10px 0px;
    flex-direction: column;
  }
`

export const TextExpand = styled.div`
  color: #5f6062;
  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 15px;
  }
`

export const ExpandContainter = styled.div`
  padding: 30px;

  @media (max-width: 480px) {
    padding: 30px 10px;
  }
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 22px;
`

interface InputProps {
  inputhWidth?: string
}

export const Column = styled.div`
  width: ${({ inputhWidth }: InputProps) =>
    inputhWidth ? inputhWidth : '400px'};
`

export const StyledInput = styled(Input)`
  height: 40px;
  width: 100%;
  border: 1px solid #bebebe;
  border-radius: 0;
  margin-top: 5px;
`

export const RequiredSpan = styled.span`
  color: #e61737;
  margin: 0 5px;
`
export const InputTitleContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`
export const Label = styled.div`
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
`

export const ErrorMsg = styled.div`
  height: 16px;
  width: 127.9px;
  color: #e61737;
  font-size: 12px;
  letter-spacing: 0.15px;
  line-height: 16px;
`

export const FormInfo = styled.div`
  width: 30%;
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;

  @media (min-width: 320px) and (max-width: 480px) {
    margin-top: 15px;
    width: 100%;
  }
`

export const RedTitle = styled.div`
  display: flex;
`

export const RedLabel = styled.div`
  color: ${RED};
  margin-left: 15px;
  font-weight: normal;
  font-size: 14px;
`

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 24px;
  align-items: center;
`

export const InputsContainer = styled.div`
  width: 50%;
  margin-top: 5px;
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const SmallInputsContainer = styled.div`
  margin-top: 5px;
  width: 45%;

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const TwoInputsContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (min-width: 320px) and (max-width: 480px) {
    flex-wrap: wrap;
    width: 100%;
  }
`

export const StyledRadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  .ant-radio-group {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .ant-checkbox-group {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
`
export const SizeStyledRadioGroup = styled.div`
  display: inline-block;
  width: 100%;

  .ant-radio-wrapper {
    width: 47%;
  }
`
export const ButtonWrapper = styled.div`
  margin-bottom: 10px;
  margin-top: 30px;
  text-align: left;
  .ant-btn-primary {
    background-color: #4a90e2;
    border-color: #4a90e2;
    width: 93px;
  }
  .ant-btn-primary:hover {
    background-color: #4a90e2;
    border-color: #4a90e2;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    .ant-btn-primary {
      width: 100%;
    }
  }
`
export const GenderSizeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;

  & > div {
    width: 100%;
  }

  & > div:first-child {
    margin-bottom: 10px;
  }

  label {
    margin-right: 0px;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`
export const UploadedFile = styled.div`
  color: #bebebe;
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 23px;
  margin-top: 10px;
`

export const StyledUpload = styled(Upload)`
  margin-top: 18px;
  display: flex;
  flex-flow: column;
  .ant-upload.ant-upload-select {
    width: 100%;
    border: 1px dashed #96acc4;
    border-radius: 3px;
    transition: all .25s;
  }
  .ant-upload.ant-upload-select:hover {
    cursor: pointer;
    background: #ecf5ff;
  }
  .ant-upload span {
    width: 100%;
    padding: 10px 6px;
    display: flex;
    justify-content: center;
  }
  .ant-upload-list-item {
    max-width: 100%;
    width: fit-content;
  }
  .ant-upload-list-item:hover .ant-upload-list-item-info {
    background: none !important;
  }
  .ant-upload-select-picture-card {
    border: 1px solid ${RED};
    width: 268px;
    height: 44px;
    margin-top: 10px;
    background: ${WHITE};
    border-radius: 1px;
    @media (max-width: 767px) {
      width: 100%;
      height: 54px;
    }
  }
  .anticon.anticon-close {
    opacity: 1 !important;
    font-size: 14px;
    top: 4px;
    right: -6px;
    transition: all .25s;
  }
  .anticon.anticon-close:hover {
    color: ${RED} !important;
  }
  .ant-upload-list.ant-upload-list-text {
    padding-right: 6px;
    margin-top: 4px;
  }
  .ant-upload-disabled {
    background: whitesmoke;
  }
  @media (max-width: 698px) {
    .ant-upload span {
      padding: 14px 6px;
    }
  }
`

export const UploadButton = styled.div`
  color: #4f8acc;
  display: flex;
  align-items: center;
  margin-left: 16px;
  margin-right: 20px;
`

export const UploadIcon = styled(Icon)`
  margin-right: 16px;
`

export const CheckIcon = styled(Icon)`
  display: block;
  color: #79cc79;
  font-size: 38px;
  margin-top: 12px;
`

export const InfoTitle = styled.div`
  font-family: Avenir;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
`

export const InfoUser = styled.div`
  font-family: Avenir;
  font-size: 16px;
  margin: 12px 0 0 -38px;
  color: black;
  text-align: center;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/WarrantyProgram/styledComponents.tsx